module.exports = __webpack_public_path__ + "static/media/follow.09c68143.svg";